import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  MediaObject,
  Tooltip,
  Icon,
} from '@salesforce/design-system-react';

import useDebounce from '../../hooks/useDebounce';

import CollaboratorComboBox from '../App/CollaboratorComboBox';
import PillJourney from '../../Components/Entry/PillJourney';

const CollaboratorModal = (props) => {
  const { onChange, onCollaboratorsChange, journeyId } = props;
  const [searchTerm, setSearchTerm] = useState('');
  const [collaboratorSearchTerm, setCollaboratorSearchTerm] = useState('');
  const [collaborators, setCollaborators] = useState([]);
  const [pillOptions, setPillOptions] = useState([]);

  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const debouncedCollaboratorSearchTerm = useDebounce(
    collaboratorSearchTerm,
    500
  );

  useEffect(() => {
    if (debouncedSearchTerm) {
      onChange(debouncedSearchTerm);
    }

    if (debouncedCollaboratorSearchTerm) {
      onCollaboratorsChange(debouncedCollaboratorSearchTerm);
    }
  }, [debouncedSearchTerm, debouncedCollaboratorSearchTerm]);

  return (
    <Card
      hasNoHeader={true}
      className="slds-p-around_medium"
      style={{
        backgroundColor: '#f2f2f2',
        border: '1px solid #dddbda',
        boxShadow: '3px 3px 3px 0px #d3d3d3',
      }}
    >
      <MediaObject
        body={
          <div>
            <span>Add Collaborators to Your Journey</span>&nbsp;
            <Tooltip
              align="right"
              content="Note: Full email addresses are needed to search a User. Collaborators will be given Read-Only access to your journey and will be able to generate Quip and Google Slide outputs. If you do not find a user, send them an email using the 'Invite Collaborators by Email' option"
              variant="learnMore"
            />
          </div>
        }
        figure={
          <Icon
            category="custom"
            containerStyle={{
              backgroundColor: 'rgba(0, 112, 210, 0.4)',
            }}
            name="custom103"
            size="medium"
          />
        }
        verticalCenter
      />

      <div className="slds-m-vertical_medium">
        <CollaboratorComboBox
          options={[...props.collaborator]}
          inputValue={collaboratorSearchTerm}
          isLoading={props.isLoadingCollaborator}
          onChange={(e) => setCollaboratorSearchTerm(e)}
          setCollaborators={(value) => setCollaborators(value)}
        ></CollaboratorComboBox>

        <div className="slds-m-vertical_medium slds-align-absolute_center slds-text-title_caps">
          - OR -
        </div>

        <PillJourney
          pillOptions={pillOptions}
          journeyEmail={props.journeyEmail}
          setPillOptions={(value) => setPillOptions(value)}
        />
      </div>
      <div>
        <Button
          key="promptBtn"
          variant="brand"
          label="Add Collaborators"
          onClick={() => {
            props.onSubmit({ collaborators, journeyId, pillOptions });
          }}
        />
      </div>

      {props.error ? (
        <div className="slds-text-align_center slds-text-color_error slds-m-around_small">
          {props.error}
        </div>
      ) : null}
    </Card>
  );
};

export default CollaboratorModal;
